import { createContext } from "react";

import type { Time } from "~/tools/date-time/time";
import type { Impulse } from "~/tools/impulse";

import type { TimeRange } from "../../../../../app/state/view/timeline/TimeRange";

export interface MonitorStatusDrawerContextValue {
	timestamp: Impulse<Time>;
	timeRange: Impulse<TimeRange>;
}

export const MonitorStatusDrawerContext = createContext<null | MonitorStatusDrawerContextValue>(null);
